import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import { FC, useEffect, useState } from 'react';
import { useDebounceCallback } from '../../../../../hooks/useDebounceValue';
import { Input } from '../../../../components-v2/Input';
import { Label } from '../../../../components-v2/Label';
import { useJobTitleFilter } from '../hooks/useJobTitleFilter';
import { styleSheet } from './styles';

interface JobTitleFiltersProps {
	className?: string;
	styles?: (StyleDeclarationValue | false)[];
	filter: Api.IBulkContactsRequest;
	onChangeFilter: (filter: Api.IBulkContactsRequest) => void;
}

const DEBOUNCE_MS = 300;

export const JobTitleFilters: FC<JobTitleFiltersProps> = ({ className, styles = [], filter, onChangeFilter }) => {
	const { jobTitle, setJobTitle } = useJobTitleFilter({ filter, onChangeFilter });

	const [localJobTitle, setLocalJobTitle] = useState(jobTitle);

	useEffect(() => {
		setLocalJobTitle(jobTitle);
	}, [jobTitle]);

	const debouncedSetJobTitle = useDebounceCallback((value: string) => setJobTitle(value), DEBOUNCE_MS);

	const handleJobTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setLocalJobTitle(value);
		debouncedSetJobTitle(value);
	};

	return (
		<div className={`${css(styleSheet.container, ...(styles?.filter(Boolean) || []))} ${className || ''}`}>
			<div className={css(styleSheet.fieldContainer)}>
				<Label htmlFor='people-job-title' styles={[styleSheet.fieldLabel]}>
					Job Title
				</Label>
				<Input
					id='people-job-title'
					type='text'
					value={localJobTitle}
					onChange={handleJobTitleChange}
					placeholder='e.g., Financial Advisor'
					autoComplete='off'
				/>
			</div>
		</div>
	);
};
